// Pagina clientes

import React from 'react';
import { useEffect, useState } from 'react';
import { Alert } from "@mui/material";
import { useUser } from '../UserContext';
import ClientList from '../components/ClientList';
import ClientDetails from '../components/ClientDetails';
import { apiFetch } from '../fetchWrapper';

export default function Clients() {

  const [clients, setClients] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedClient, setSelectedClient] = React.useState(null);


  // Fetch all clients on mount
  useEffect(() => {
    setLoading(true);

    apiFetch("/api/clients")
      .then(res => {
        if (!res) return; // apiFetch may handle 401 internally
        // make sure we parse JSON
        return res.json?.() || res;
      })
      .then(data => {
        setClients(Array.isArray(data) ? data : []);
        setError(null);
      })
      .catch(err => setError(err.message || "Failed to fetch clients"))
      .finally(() => setLoading(false));
  }, []);

  const handleSaveClient = (savedClient) => {
    if (!savedClient) {
      return;
    }

    setClients((prev) => {
      const exists = prev.some(c => c.id === savedClient.id);
      if (exists) {
        return prev.map(c => c.id === savedClient.id ? savedClient : c);
      }
      return [...prev, savedClient];
    });
  };

  const handleDeleteClient = (clientId) => {
    setClients(prev => prev.filter(c => c.id !== clientId));
  };

  return (
    <>
      <section>
        {selectedClient ? (
          <ClientDetails
            client={selectedClient}
            onBack={() => setSelectedClient(null)}
          />
        ) : (
          <ClientList clients={clients} onSaveClient={handleSaveClient} onDeleteClient={handleDeleteClient} onSelect={setSelectedClient}
          />
        )}

      </section>
    </>
  );
}
